import { baseApi } from "../../redux/baseAPI";
import { patientApi } from "./patientService";

export const allergiesApi = baseApi.injectEndpoints({
  tagTypes: ["Allergies"],
  endpoints: (builder) => ({
    getAllergies: builder.query({
      query: (body) => {
        if (body?.pid){
        return {
          url: `/prescriptions/ds_patient_allergies.json`,
          method: "GET",
          params: body,
        };}
      },
      transformResponse: (response, meta, arg) => response.response,
      providesTags: (result) => {
        try {
          return result
            ? [
                ...(Array.isArray(result?.data) 
                  ? result.data.map(({ id }) => ({ type: "Allergies", id }))
                  : []),
                { type: "Allergies", id: "LIST" },
              ]
            : [{ type: "Allergies", id: "LIST" }];
        } catch (error) {
          return [{ type: "Allergies", id: "LIST" }];
        }
      },
    }),
    getAllergiesMeta: builder.query({
      query: (patientId) => {
        return {
          url: `/prescriptions/ds_get_allergy_settings.json`,
          method: "GET",
          params: { pid: patientId, type: "allergies" },
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    deactivateAllergy: builder.mutation({
      query: (body) => ({
        url: `/prescriptions/ds_update_allergy.json`,
        method: "POST",
        data: body,
        params: {
          pid: body.pid,
          current_loc: "patient/allergies/allergies",
        },
      }),
      transformResponse: (response, meta, arg) => response,
      async onQueryStarted({ id, ...patch }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          allergiesApi.util.updateQueryData("getAllergies", id, (draft) => {
            Object.assign(draft, patch);
          })
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
      invalidatesTags: (result, error, { id }) => [{ type: "Allergies", id }],
    }),
    addAllergy: builder.mutation({
      // note: an optional `queryFn` may be used in place of `query`
      query: (body) => {
        return {
          url: `/prescriptions/ds_add_allergy.json`,
          method: "POST",
          data: {
            pid: body[1].pid,
            encounter: body[1].encounter,
            data: body[0],
          },
          params: { pid: body[1].pid, encounter: body[1].encounter },
        };
      },
      transformResponse: (response, meta, arg) => response.response,
      async onQueryStarted({ id, ...patch }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          allergiesApi.util.updateQueryData("getAllergies", id, (draft) => {
            Object.assign(draft, patch);
          })
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
      invalidatesTags: (result, error, { id }) => [{ type: "Allergies", id }],
    }),
    updateAllergy: builder.mutation({
      // note: an optional `queryFn` may be used in place of `query`
      query: (body) => {
        let dataObj = [...body.data[0]];
        return{
        url: `/prescriptions/ds_update_allergy.json`,
        method: "POST",
        data: {...dataObj[0]},
        params: {...body.data[1]},
      }
      },
      transformResponse: (response, meta, arg) => response?.response,
      async onQueryStarted({ id, ...patch }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          allergiesApi.util.updateQueryData("getAllergies", id, (draft) => {
            Object.assign(draft, patch);
          })
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
      invalidatesTags: (result, error, { id }) => [{ type: "Allergies", id }],
    }),
    patientHasNoAllergy: builder.mutation({
      query: (body) => ({
        url: `/prescriptions/patient_has_no_allergy_toggle.json`,
        method: "POST",
        data: body,
        params: {
          pid: body.pid,
          has_no_allergy: body.has_no_allergy,
          current_loc: "patient/allergies/allergies",
        },
      }),
      transformResponse: (response, meta, arg) => response,
      async onQueryStarted({ id, ...patch }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          patientApi.util.updateQueryData("getPatientDemographics", id, (draft) => {
            Object.assign(draft, patch);
          })
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
      invalidatesTags: ["PatientDemographics"],
    }),
  }),
});

export const {
  useGetAllergiesQuery,
  useGetAllergiesMetaQuery,
  useDeactivateAllergyMutation,
  usePatientHasNoAllergyMutation,
  useAddAllergyMutation,
  useUpdateAllergyMutation,
} = allergiesApi;
